import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=e08d3640"
import script from "./AccountPage.vue?vue&type=script&lang=js"
export * from "./AccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e08d3640')) {
      api.createRecord('e08d3640', component.options)
    } else {
      api.reload('e08d3640', component.options)
    }
    module.hot.accept("./AccountPage.vue?vue&type=template&id=e08d3640", function () {
      api.rerender('e08d3640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/AccountPage.vue"
export default component.exports